export default {
  methods: {
    loginValidate() {
      if (this.login) {
        const errors = []

        if (!(this.inputValue.length >= 3 && this.inputValue.length <= 24)) {
          errors.push({ text: '3-25 символов', status: false })
        } else {
          errors.push({ text: '3-25 символов', status: true })
        }

        if (!/^[a-z0-9а-яё].*$/u.test(this.inputValue)) {
          errors.push({ text: 'Начинаеться с буквы или цифры', status: false })
        } else {
          errors.push({ text: 'Начинаеться с буквы или цифры', status: true })
        }

        if (/[а-яё]/g.test(this.inputValue)) {
          errors.push({
            text: 'Может содержать буквы только латинского алфавита',
            status: false,
          })
        } else {
          errors.push({
            text: 'Может содержать буквы только латинского алфавита',
            status: true,
          })
        }
        if (/([^._\-@0-9a-zа-яё])/g.test(this.inputValue)) {
          errors.push({
            text: 'Из спецсимволов может содержать только - _ . @',
            status: false,
          })
        } else {
          errors.push({
            text: 'Из спецсимволов может содержать только - _ . @',
            status: true,
          })
        }
        const isValidUser = () => {
          return errors.filter((error) => error.status === false)
        }

        if (isValidUser().length) {
          this.message = errors
          this.status = 'error'
          return false
        } else {
          this.message = ''
          this.status = 'done'
          this.isEmptyValue = false
          return true
        }
      } else {
        this.message = ''
        this.status = 'done'
        this.isEmptyValue = true
        return true
      }
    },
  },
}
